import React from 'react';
import { Link } from 'react-router-dom'
import './linkbox.css'

interface IProps {
    text: string,
    img: string,
    link: string,
    className?: string
}

function LinkBox({text, img, link, className}: IProps) {
    return (
        <Link to={link} className={className}>
            <div className={`link-box text-xl md:text-4xl font-bold font-raleway text-center bg-${img}`}>
                {text}
            </div>
        </Link>
    );
}

export default LinkBox;